import { PAGE_URLS } from "../constants/hrefLinks"
import { getProfilePicPath } from "../constants/instructorConstants"
import { PROFILE_PIC_URL } from "../constants/pathConstants"
import { INSTRUCTOR_GENDERS, INSTRUCTOR_SCHOOLS, LANGUAGES } from "../constants/searchConstants"
import { ChatInteractions, UserData, UserDetails } from "../server/types"
import { AccountStatus } from "../types/types"

// User state data class
class UserStateData {
	loggedIn: boolean
	userData: UserData | undefined
	interactions: ChatInteractions[] = []
	likedInstructors: string[] = []
	likedInstructorDetails: UserDetails[] = []
	videoFileName: string = ''
	transactionUrl: string = PAGE_URLS.DASHBOARD_CUSTOMER

	constructor() {
		this.loggedIn = false
		this.loadLikedInstructors()
	}

	public logOut() {
		this.loggedIn = false
		this.userData = undefined
		this.interactions = []
		this.likedInstructors = []
	}

	// ================================================== CHAT/INTERACTIONS =============================================

	public setInteractions(interactions: ChatInteractions[]) {
		this.interactions = interactions
	}

	// public addInteractions(interactions: ChatInteractions[]) {
	// 	this.reviews = [...this.reviews, ...reviews]
	// }

	public createNewChat(instructorImgSrc: string, instructorName: string) {
		// let newChat = {
		// 	profileImgSrc: instructorImgSrc,
		// 	profileName: instructorName,
		// 	chatMessage: '',
		// 	chatId: ''
		// }
	}

	// ================================================== LIKED INSTRUCTORS =============================================

	private loadLikedInstructors() {
		const storedLikedProfilesStr: string | null = window.localStorage.getItem('likedProfiles')
		if (storedLikedProfilesStr !== null) {
			// storedLikedProfilesStr.split(',').forEach((value: string) => this.likedInstructors.push(value))
			this.likedInstructors = storedLikedProfilesStr.split(',')
		}
	}

	public addLikedInstructor(instructorId: string) {
		if (!this.likedInstructors.includes(instructorId)) {
			this.likedInstructors.push(instructorId)
		}
		this.saveLikedProfiles()
	}

	public toggleLikesInstructor(instructorId: string) {
		let newArr: string[] = []
		let idFound: boolean = false
		if (this.likedInstructors.length > 0) {
			this.likedInstructors.forEach((id: string) => {
				if (id == instructorId) {
					idFound = true
				} else {
					newArr.push(id as string)
				}
			})
		}
		
		if (idFound === false) {
			newArr.push(instructorId)
		}
		this.likedInstructors = newArr
		this.saveLikedProfiles()
	}

	private saveLikedProfiles() {
		if (this.likedInstructors.length === 0) {
			window.localStorage.removeItem('likedProfiles')
		} else {
			window.localStorage.setItem('likedProfiles', this.likedInstructors.join(','))
		}
	}

	public setLikedInstructorDetails(details: UserDetails[]) {
		// console.log('setLikedInstructorDetails() details =', details)
		this.likedInstructorDetails = details
	}

	// ==================================================== VIDEO =================================================

	public setVideoFileName(fileName: string) {
		this.videoFileName = fileName
	}

	// ==================================================== IMAGES =================================================

	public setProfilePics(value: string) {
		if (this.userData?.profile_pics) {
			this.userData.profile_pics = value
		}
	}

	// ===================================================== GETTERS ==============================================

	// Called on page open to get user data from session
	public getUserData() {
		return this.userData
	}

	public getId(): string {
		return this.userData?.id ? this.userData.id : ''
	}

	/**
	 * returns the user icon url path or path to a default icon
	 */
	public getUserIconUrl(): string | undefined {
		// return '/imgs/icons/icon-user.svg'
		return this.userData?.profile_pics ? getProfilePicPath(this.userData.profile_pics, 0) : undefined
	}

	public getAllUserIconUrls(): string[] {
		const splitProfilePics: string[] | undefined = this.userData?.profile_pics ? this.userData.profile_pics.split(',') : undefined
		if (splitProfilePics) { // .length > 0) {
			return splitProfilePics.map((picUrl: string) => `${PROFILE_PIC_URL}${picUrl}`)
		}
		return []
	}

	public getProfilePics(): string {
		return this.userData?.profile_pics ? this.userData.profile_pics : ''
	}

	public getSplitProfilePics(): string[] {
		return this.userData?.profile_pics ? this.userData.profile_pics.split(',') : []
	}

	/**
	 * Get the Users name
	 * @returns string - Name of the User from the user data or fallback of 'UNKNOWN'
	 */
	public getUsersName(): string {
		return this.userData?.name ? this.userData.name : 'UNKNOWN'
	}

	public getUsersEmail(): string {
		return this.userData?.email ? this.userData.email : 'no@email'
	}

	/**
	 * Get the Users Age in years
	 * @returns string - Age of the User based on dob in user data or fallback of 0
	 */
	public getAge(): string {
		// let dob: Date = this.userData?.dob ? new Date(this.userData.dob) : new Date()
		// return Math.floor((Date.now() - dob.getTime()) / 31556952000).toString()
		if (this.userData?.dob) {
			let dob: Date = new Date(this.userData.dob)
			return Math.floor((Date.now() - dob.getTime()) / 31556952000).toString()
		}
		return '0'
	}

	public getDob(): string | undefined {
		return this.userData?.dob ? this.userData.dob.split('T')[0] : undefined
	}

	/**
	 * Get the Users Phone Number
	 * @returns string - Phone number of the User from user data or fallback of '+?? ???? ??????'
	 */
	public getPhoneNumber(): string {
		return this.userData?.phone ? this.userData.phone : '+?? ???? ??????'
	}

	/**
	 * Get the users email
	 * @returns string - Email of the User from user data or fallback of '??@??.??'
	 */
	public getEmail(): string {
		return this.userData?.email ? this.userData.email : '??@??.??'
	}

	public getAddress(): string {
		return this.userData?.address ? this.userData.address : ''
	}

	public getCountry(): string {
		return this.userData?.country ? this.userData.country : ''
	}

	public getGender(): string | undefined {
		if (this.userData?.gender == undefined) {
			return undefined
		} else {
			return INSTRUCTOR_GENDERS[this.userData.gender] ? INSTRUCTOR_GENDERS[this.userData.gender] : ''
		}
		// if (this.userData?.gender) {
		// 	return INSTRUCTOR_GENDERS[this.userData.gender] ? INSTRUCTOR_GENDERS[this.userData.gender] : ''
		// } else if (this.userData?.gender == 0) {
		// 	return INSTRUCTOR_GENDERS[0]
		// } else {
		// 	return undefined
		// }
		// return this.userData?.gender && INSTRUCTOR_GENDERS[this.userData.gender] ? INSTRUCTOR_GENDERS[this.userData.gender] : ''
	}

	public getSkiSchool(): string | undefined {
		if (this.userData?.school == undefined) {
			return undefined
		} else {
			return INSTRUCTOR_SCHOOLS[this.userData.school] ? INSTRUCTOR_SCHOOLS[this.userData.school] : ''
		}
	}

	public getLanguage(): string | undefined {
		if (this.userData?.language) {
			return LANGUAGES[this.userData.language] ? LANGUAGES[this.userData.language] : 'English'
		} else {
			return undefined
		}
		// return this.userData?.language ? this.userData.language : ''
		// return this.userData?.language && LANGUAGES[this.userData.language] ? LANGUAGES[this.userData.language] : undefined // 'English'
	}

	public getLanguages(): string | undefined {
		return this.userData?.languages ? this.userData.languages : undefined
	}

	public getTerrains(): string | undefined {
		return this.userData?.terrains ? this.userData.terrains : undefined
	}

	public getCity(): string {
		return this.userData?.city ? this.userData.city : ''
	}

	public getLevel(): string {
		return this.userData?.level ? this.userData.level : ''
	}

	public getGroupSize(): string {
		return this.userData?.group_size ? this.userData.group_size : ''
	}

	public getQualifications(): string {
		return this.userData?.qualifications ? this.userData.qualifications : ''
	}

	public getCertificateFilePath(): string | undefined {
		return this.userData?.certificateFilePath ? this.userData.certificateFilePath : undefined
	}

	public getIdFilePath(): string | undefined {
		return this.userData?.idFilePath ? this.userData.idFilePath : undefined
	}

	public getInteractionIds(): string {
		// const interactionIds: string[] = this.userData?.interactions ? this.userData.interactions.split
		return this.userData?.interactions ? this.userData.interactions : ''
	}

	public getInteractions(maxCount: number = 0): ChatInteractions[] {
		return maxCount === 0 ? this.interactions : this.interactions.slice(0, maxCount)
	}

	public getInteractionData(index: number = 0): ChatInteractions | undefined {
		return this.interactions[index] ? this.interactions[index] : undefined
	}

	public getLikedInstructorDetails(): UserDetails[] {
		return this.likedInstructorDetails
	}

	public getChatDataStr(): string {
		return this.interactions.length > 0 && this.interactions[0].interaction_data ? this.interactions[0].interaction_data : ''
	}

	public getAboutText(): string | undefined {
		return this.userData?.about_text ? this.userData.about_text : undefined
	}

	public getPrice(): string | undefined {
		return this.userData?.price ? Number(this.userData.price).toFixed(2) : undefined
	}
	public getPrice_2(): string | undefined {
		return this.userData?.price_2 ? Number(this.userData.price_2).toFixed(2) : undefined
	}
	public getPrice_3(): string | undefined {
		return this.userData?.price_3 ? Number(this.userData.price_3).toFixed(2) : undefined
	}
	public getPrice_4(): string | undefined {
		return this.userData?.price_4 ? Number(this.userData.price_4).toFixed(2) : undefined
	}

	public getInstructorUpdateUserData(): UserData {
		// const shortDob: string | undefined = this.getDob()
		return {
			name: this.userData ? this.userData.name : '',
			email: this.getEmail(),
			status: this.userData ? this.userData.status : 'UNKNOWN',
			phone: this.getPhoneNumber(),
			dob: this.getDob(),
			interactions: '',
			languages: this.userData?.languages,
			terrains: this.userData?.terrains,
			school: this.userData?.school,
			certificateFilePath: this.getCertificateFilePath(),
			idFilePath: this.getIdFilePath(),
			bankCountry: this.getBankCountry(),
			bankName: this.getBankName(),
			bankAccountNumber: this.getBankAccountNumber(),
			bankSortCode: this.getBankSortCode(),
			bankSwiftBic: this.getBankSwiftBic(),
			level: this.getLevel(),
			about_text: this.getAboutText(),
			price: this.getPrice(),
			price_2: this.getPrice_2(),
			price_3: this.getPrice_3(),
			price_4: this.getPrice_4(),
			group_size: this.getGroupSize() == '' ? undefined : this.getGroupSize(),
			country: this.getCountry()
		}
	}

	// public getUserUpdateUserData(): UserData {
	// 	// const shortDob: string | undefined = this.getDob()
	// 	return {
	// 		name: this.userData ? this.userData.name : '',
	// 		email: this.getEmail(),
	// 		address: this.getAddress(),
	// 		country: this.getCountry(),
	// 		phone: this.getPhoneNumber(),
	// 		gender: this.userData?.gender,
	// 		language: this.userData?.language,
	// 		city: this.getCity()
	// 	}
	// }

	public getStatus(): string {
		return this.userData?.status ? this.userData.status : 'UNKNOWN'
	}
	
	public getStatusMessage(): string {
		if (this.userData?.status) {
			if (this.userData.status === AccountStatus.ACTIVE) {
				return 'Active'
			} else if (this.userData.status === AccountStatus.VERIFY_EMAIL) {
				return 'Email not verified'
			} else if (this.userData.status === AccountStatus.CERTIFICATE_NOT_PROVIDED) {
				return 'Proof document required'
			} else if (this.userData.status === AccountStatus.CERTIFICATE_UNDER_REVIEW) {
				return 'Documents under review'
			} else if (this.userData.status === AccountStatus.FLAGGED) {
				return 'Account Flagged'
			} else if (this.userData.status === AccountStatus.DISABLED) {
				return 'Disabled'
			} else if (this.userData.status === AccountStatus.BANNED) {
				return 'Banned'
			} else if (this.userData.status === AccountStatus.FULLY_BOOKED) {
				return 'Fully Booked'
			} else if (this.userData.status === AccountStatus.INCOMPLETE) {
				return 'Incomplete'
			}
		}
		return 'UNKNOWN'
	}

	// ===================================================== BANK ===============================================

	public getBankCountry(): string | undefined {
		return this.userData?.bankCountry ? this.userData.bankCountry : undefined
	}
	public getBankName(): string {
		return this.userData?.bankName ? this.userData.bankName : ''
	}
	public getBankAccountNumber(): string {
		return this.userData?.bankAccountNumber ? this.userData.bankAccountNumber : ''
	}
	public getBankSortCode(): string {
		return this.userData?.bankSortCode ? this.userData.bankSortCode : ''
	}
	public getBankSwiftBic(): string {
		return this.userData?.bankSwiftBic ? this.userData.bankSwiftBic : ''
	}
	
	/**
	 * returns true if the user is logged in and already and instructor, otherwise false
	 * used to add/remove "Become and Instructor" cta
	 */
	public isAnInstructor(): boolean {
		return this.userData?.isInstructor ? this.userData.isInstructor : false
	}

	public toggleActiveState() {
		if (this.userData?.status) {
			if (this.userData.status === AccountStatus.ACTIVE) {
				this.userData.status = AccountStatus.DISABLED
			} else {
				this.userData.status = AccountStatus.ACTIVE
			}
		}
	}

	public toggleSuspendedState() {
		if (this.userData?.status) {
			if (this.userData.status != AccountStatus.BANNED) {
				this.userData.status = AccountStatus.BANNED
			} else {
				this.userData.status = AccountStatus.ACTIVE
			}
		}
	}

	// ===================================================== GETTERS ==============================================

	public setUserData(userData: UserData) {
		this.userData = userData
		this.loggedIn = true
		this.loadLikedInstructors()
	}

	public setName(value: string | undefined) {
		if (this.userData && value) {
			this.userData.name = value
		}
	}
	public setEmail(value: string | undefined) {
		if (this.userData && value) {
			this.userData.email = value
		}
	}
	public setAddress(value: string | undefined) {
		if (this.userData && value) {
			this.userData.address = value
		}
	}
	public setCountry(value: string | undefined) {
		if (this.userData && value) {
			this.userData.country = value
		}
	}
	public setCity(value: string | undefined) {
		if (this.userData && value) {
			// this.userData.language = value
			this.userData.city = value
		}
	}
	public setPhoneNumber(value: string | undefined) {
		if (this.userData && value) {
			this.userData.phone = value
		}
	}
	public setGender(value: string | undefined) {
		if (this.userData && value) {
			this.userData.gender = INSTRUCTOR_GENDERS.indexOf(value)
		}
	}
	public setLevel(value: string | undefined) {
		if (this.userData && value) {
			this.userData.level = value
		}
	}
	public setGroupSize(value: string | undefined) {
		if (this.userData && value) {
			this.userData.group_size = value
		}
	}
	public setSkiSchool(value: string | undefined) {
		if (this.userData && value) {
			this.userData.school = INSTRUCTOR_SCHOOLS.indexOf(value)
		}
	}
	public setLanguage(value: string | undefined) {
		if (this.userData && value) {
			// this.userData.language = value
			this.userData.language = LANGUAGES.indexOf(value)
		}
	}
	public setLanguages(value: string | undefined) {
		if (this.userData && value) {
			this.userData.languages = value
		}
	}
	public setTerrains(value: string | undefined) {
		if (this.userData && value) {
			this.userData.terrains = value
		}
	}

	public setCertificateFilePath(value: string) {
		if (this.userData && value) {
			this.userData.certificateFilePath = value
		}
	}

	public setIdFilePath(value: string) {
		if (this.userData && value) {
			this.userData.idFilePath = value
		}
	}

	public setStatus(value: string) {
		if (this.userData && value) {
			this.userData.status = value
		}
	}

	public setAboutText(value: string | undefined) {
		if (this.userData && value) {
			this.userData.about_text = value
		}
	}

	public setPrice(value: string | undefined) {
		if (this.userData && value) {
			this.userData.price = Number(value).toFixed(2)
		}
	}
	public setPrice_2(value: string | undefined) {
		if (this.userData && value) {
			this.userData.price_2 = Number(value).toFixed(2)
		}
	}
	public setPrice_3(value: string | undefined) {
		if (this.userData && value) {
			this.userData.price_3 = Number(value).toFixed(2)
		}
	}
	public setPrice_4(value: string | undefined) {
		if (this.userData && value) {
			this.userData.price_4 = Number(value).toFixed(2)
		}
	}

	// =============================================== BANK =====================

	public setBankCountry(value: string | undefined) {
		if (this.userData && value) {
			this.userData.bankCountry = value
		}
	}
	public setBankName(value: string | undefined) {
		if (this.userData && value) {
			this.userData.bankName = value
		}
	}
	public setBankAccountNumber(value: string | undefined) {
		if (this.userData && value) {
			this.userData.bankAccountNumber = value
		}
	}
	public setBankSortCode(value: string | undefined) {
		if (this.userData && value) {
			this.userData.bankSortCode = value
		}
	}
	public setBankSwiftBic(value: string | undefined) {
		if (this.userData && value) {
			this.userData.bankSwiftBic = value
		}
	}
	
	public setDob(valueDate: number, valueMonth: number, valueYear: number) {
		const newDate: Date = new Date()
		newDate.setDate(valueDate)
		newDate.setMonth(valueMonth)
		newDate.setFullYear(valueYear)
		if (this.userData) {
			// this.userData.dob = `${newDate.getFullYear()}-${newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}T00:00:00.000Z`
			// this.userData.dob = `${newDate.getFullYear()}-${newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
			this.userData.dob = `${newDate.getFullYear()}-${newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
		}
	}

	public setQualifications(value: string | undefined) {
		if (this.userData && value) {
			this.userData.qualifications = value
		}
	}
}

export const userStateData: UserStateData = new UserStateData()